import { library, config } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faEye,
    faEyeSlash,
    faTimes,
    faTrashAlt,
    faCaretDown,
    faChevronDown,
    faListUl,
    faCameraRetro,
    faExclamation,
    faCheck,
    faFilePdf,
    faCopy,
    faShare,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus,
    faSort,
} from "@fortawesome/free-solid-svg-icons";

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false;

// You can add your icons directly in this plugin. See other examples for how you
// can add other styles or just individual icons.
library.add(
    faCaretDown,
    faTimes,
    faTrashAlt,
    faEyeSlash,
    faEye,
    faChevronDown,
    faListUl,
    faCameraRetro,
    faExclamation,
    faCheck,
    faFilePdf,
    faCopy,
    faShare,
    faMagnifyingGlassPlus,
    faMagnifyingGlassMinus,
    faSort
);

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component("fa-icon", FontAwesomeIcon);
});
